const Layout = () => System.import('../../Shared/Layout/App/View/Layout.vue');
const Home = () => System.import('../App/View/Home.vue');

export const HomeRoutes = [
  { path: '/',
    component: Layout,
    children: [
      { path: "home",  component: Home, name: 'home', meta: { auth: true } }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/Home/Rotas/Routes.js